import clsx from 'clsx';
import { formatRemainingTime } from '../skillTestUtils';

type TimerProps = {
  secondsRemaining: number;
};

export function Timer({ secondsRemaining }: TimerProps) {
  const isUrgent = secondsRemaining <= 60;

  return (
    <div className='flex flex-col items-center gap-1'>
      <span className='text-[11px] font-semibold uppercase tracking-[0.14em] text-[#6B7280]'>
        Time remaining
      </span>
      <div
        className={clsx(
          'min-w-[112px] rounded-[12px] px-4 py-3 text-center font-display text-[32px] font-bold leading-none tabular-nums transition-colors duration-300',
          isUrgent
            ? 'bg-[#FEE2E2] text-[#DC2626] shadow-[0_0_0_1px_rgba(220,38,38,0.15)]'
            : 'bg-[#EEF4FF] text-[#0055FF] shadow-[0_0_0_1px_rgba(0,85,255,0.12)]'
        )}
        aria-live='polite'
        aria-atomic='true'
      >
        {formatRemainingTime(secondsRemaining)}
      </div>
    </div>
  );
}
